export enum SnagStatusType {
    Reported = 0,
    Rejected = 1,
    Approved = 2,
    Reviewed = 3,
}
